const $ = window.jQuery;

const accordion = {
    init: () => {

        /*
         *   Accessible accordion script from: https://www.w3.org/WAI/ARIA/apg/patterns/accordion/examples/accordion/
         *
         *   This content is licensed according to the W3C Software License at
         *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
         *
         *   Simple accordion pattern example
         */

        'use strict';

        class Accordion {
            constructor(domNode) {
                this.rootEl = $(domNode);
                this.buttonEl = this.rootEl.find('.js-accordion-trigger[aria-expanded]');

                const controlsId = this.buttonEl.attr('aria-controls');
                this.contentEl = $('#' + controlsId);

                this.open = this.buttonEl.attr('aria-expanded') === 'true';

                // add event listeners
                this.buttonEl.on('click', this.onButtonClick.bind(this));
            }

            onButtonClick() {
                this.toggle(!this.open);
            }

            toggle(open) {
                // don't do anything if the open state doesn't change
                if (open === this.open) {
                    return;
                }

                // update the internal state
                this.open = open;

                // handle DOM updates
                this.buttonEl.attr('aria-expanded', `${open}`);
                if (open) {
                    this.contentEl.removeAttr('inert');
                    this.contentEl.css("max-height", this.contentEl.find(".accordion__panel-content").innerHeight() + "px");
                } else {
                    this.contentEl.attr('inert', '');
                    this.contentEl.css("max-height", "0px");
                }
            }

            // Add public open and close methods for convenience
            open() {
                this.toggle(true);
            }

            close() {
                this.toggle(false);
            }
        }

        // init accordions
        const accordions = $('.accordion .js-accordion-header');
        accordions.each((index, accordionEl) => {
            new Accordion(accordionEl);
        });

    }
};
export default accordion;
